import PropTypes from "prop-types";

export default function SectionHeader({ eyebrow, title, description, action }) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        {eyebrow && (
          <p className="text-xs font-semibold uppercase tracking-[3px] text-cyan-300">
            {eyebrow}
          </p>
        )}
        <h2 className="mt-2 text-2xl font-semibold text-white sm:text-3xl">
          {title}
        </h2>
        {description && (
          <p className="mt-3 text-sm leading-6 text-slate-300 sm:text-base">
            {description}
          </p>
        )}
      </div>
      {action}
    </div>
  );
}

SectionHeader.propTypes = {
  eyebrow: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  action: PropTypes.node,
};
